import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form-normalize-on-blur/index';
import classnames from 'classnames';
import './index.css';

class Radio extends Component {
  render() {
    const {
      input,
      label,
      val,
      disabled,
      validate,
      theme,
      className,
      id,
    } = this.props;
    const { onChange, name, value } = input;
    const radioCSS = classnames(
      'radio',
      theme ? theme.map(css => `radio--${css}`).join(' ') : '',
      disabled ? 'radio--disabled' : ''
    );

    return (
      <fieldset className={radioCSS}>
        <input
          checked={value === val}
          type="radio"
          name={name}
          id={id ? id : `${name}-${val}`}
          value={val}
          disabled={disabled}
          validate={validate}
          onChange={onChange}
        />

        <label className={className} htmlFor={id ? id : `${name}-${val}`}>
          {label}
        </label>
      </fieldset>
    );
  }
}

Radio.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.array,
  val: PropTypes.string,
  validate: PropTypes.array,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  input: PropTypes.object,
  id: PropTypes.string,
};

const RadioField = props => <Field {...props} component={Radio} />;

export default RadioField;



// WEBPACK FOOTER //
// ./src/common/components/Radio/index.js